import { render, staticRenderFns } from "./sistema.vue?vue&type=template&id=92ce3d06&"
import script from "./sistema.vue?vue&type=script&lang=js&"
export * from "./sistema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports